import * as globals from '@wandb/weave/common/css/globals.styles';
import {hexToRGB} from '@wandb/weave/common/css/globals.styles';
import {TargetBlank} from '@wandb/weave/common/util/links';
// eslint-disable-next-line wandb/no-deprecated-imports
import styled from 'styled-components';

export const LinkBoxContainer = styled.div`
  height: 55px;
  width: 100%;

  border: 1px solid ${globals.MOON_200};
  border-radius: 8px;

  display: flex;
  align-items: center;

  padding: 0 16px;
  gap: 8px;
  font-weight: 600;
  font-size: 14px;
  line-height: 16px;

  color: ${globals.MOON_800};
  cursor: pointer;
`;

export const IconCircle = styled.div`
  background: ${hexToRGB(globals.SIENNA_300, 0.48)};
  color: ${globals.SIENNA_500};

  height: 32px;
  width: 32px;
  border-radius: 16px;

  display: flex;
  align-items: center;
  justify-content: space-around;
`;

export const StyledTargetBlank = styled(TargetBlank)`
  min-width: 235px;

  @media (max-width: 560px) {
    width: 100%;
  }
  display: flex;
  flex: 1 0 auto;
`;

export const ShareLinksContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  gap: 24px;

  margin-top: 24px;
  @media (max-width: 560px) {
    margin-bottom: 24px;
  }
`;
